<template>
  <v-dialog
    v-model="dialog"
    width="600"
    @click:outside="cancel"
  >
    <v-card light>
      <v-btn
        class="float-right"
        icon
        @click="cancel"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-card-title class="px-8 pt-12"> Rename {{ title }} </v-card-title>
      <v-card-text class="px-8">
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="item.name"
                label="Name"
                outlined
                :rules="[$rules.required]"
                maxlength="100"
                hide-details="auto"
              />
            </v-col>
            <v-col cols="auto">
              <v-btn
                x-large
                :loading="saving"
                @click="save"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
export default {
  props: {
    saveAction: { type: String, default: '' },
    title: { type: String, default: '' }
  },
  data: () => ({
    dialog: false,
    saving: false,
    valid: false,
    item: {}
  }),
  methods: {
    cancel() {
      this.dialog = false;
    },
    showDialog(item) {
      this.dialog = true;
      this.item = cloneDeep(item);
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch(this.saveAction, this.item)
          .then((data) => {
            this.$emit('save', data);
            this.$refs.form.reset();
            this.dialog = false;
            this.$root.$snackbarSuccess(`${this.title} name saved`);
          })
          .catch((error) => {
            this.logError(error);
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
